import { render, staticRenderFns } from "./OrderRecordsComponent.vue?vue&type=template&id=c39c324c&scoped=true"
import script from "./OrderRecordsComponent.vue?vue&type=script&lang=js"
export * from "./OrderRecordsComponent.vue?vue&type=script&lang=js"
import style0 from "./OrderRecordsComponent.vue?vue&type=style&index=0&id=c39c324c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c39c324c",
  null
  
)

export default component.exports